(function () {
  'use strict';

  const cache = {};

  /* ─────────────────────────────────────────
     PRODUCT CARD BUILDER
  ───────────────────────────────────────── */
  function buildCard(product) {
    const img = product.images[0]
      ? `<img src="${product.images[0].src}" alt="${product.title}" loading="lazy">`
      : '';
    return `
      <div class="card" onclick="window.location='/products/${product.handle}'" style="cursor:pointer;">
        <div class="product-img">${img}</div>
        <div class="product-content">
          <h3 class="product-title">${product.title}</h3>
          <span>${product.variants[0]?.weight ? product.variants[0].weight + ' ' + product.variants[0].weight_unit : ''}</span>
          <a href="/products/${product.handle}">Learn More</a>
        </div>
      </div>`;
  }

  /* ─────────────────────────────────────────
     AJAX PRODUCT FETCH
  ───────────────────────────────────────── */
  function fetchProducts(handle, container) {
    if (!handle || handle === '' || handle.includes('/')) return;
    if (container.dataset.loaded === 'true') return;

    if (cache[handle]) {
      renderProducts(cache[handle], container);
      return;
    }

    container.innerHTML = '<div class="tsm-loading">Loading...</div>';

    fetch(`/collections/${handle}/products.json?limit=4`)
      .then(res => res.json())
      .then(data => {
        cache[handle] = data.products;
        renderProducts(data.products, container);
      })
      .catch(() => {
        container.innerHTML = '<div class="tsm-loading">Unable to load products.</div>';
      });
  }

  function renderProducts(products, container) {
    if (!products || products.length === 0) {
      container.innerHTML = '<div class="tsm-loading">No products found.</div>';
      return;
    }
    container.innerHTML = products.map(buildCard).join('');
    container.dataset.loaded = 'true';
  }

  /* ─────────────────────────────────────────
     INIT PER MENU INSTANCE
  ───────────────────────────────────────── */
  function initMenu(menu) {
    const isFourCol = menu.classList.contains('tsm-four-col');

    /* ══════════════════════════════════════
       COL 1 — STATIC TABS
    ══════════════════════════════════════ */
    if (isFourCol) {
      const staticTabs = Array.from(menu.querySelectorAll('.tsm-static .tsm-main-tab'));

      staticTabs.forEach(tab => {
        tab.addEventListener('mouseenter', () => {
          staticTabs.forEach(t => t.classList.remove('active'));
          tab.classList.add('active');

          const groupId = tab.dataset.staticTab;

          /* Show matching content group */
          menu.querySelectorAll('.tsm-content-group').forEach(g => g.classList.remove('active'));
          const targetGroup = menu.querySelector(`.tsm-content-group[data-static-group="${groupId}"]`);
          if (!targetGroup) return;
          targetGroup.classList.add('active');

          /* Auto-activate first sub tab in this group */
          const firstSubTab = targetGroup.querySelector('.tsm-left .tsm-main-tab');
          if (firstSubTab) activateSubTab(firstSubTab, targetGroup, menu);
        });
         tab.addEventListener('click', () => {
    const url = tab.dataset.tabUrl;
    if (url) window.location = url;
  });
      });
    }

    /* ══════════════════════════════════════
       COL 2 — SUB TABS (inside each content group)
    ══════════════════════════════════════ */
    menu.querySelectorAll('.tsm-left .tsm-main-tab').forEach(tab => {
      tab.addEventListener('mouseenter', () => {
        const group = tab.closest('.tsm-content-group');
        activateSubTab(tab, group, menu);
      });
    });

    function activateSubTab(tab, group, menu) {
      /* Deactivate siblings in same tsm-left */
      const left = tab.closest('.tsm-left');
      left.querySelectorAll('.tsm-main-tab').forEach(t => t.classList.remove('active'));
      tab.classList.add('active');

      /* Show matching tab-content */
      group.querySelectorAll('.tsm-tab-content').forEach(c => c.classList.remove('active'));
      const tabId = tab.dataset.tsmTab;
      const targetContent = group.querySelector(`#${tabId}`);
      if (!targetContent) return;
      targetContent.classList.add('active');

      /* Auto-activate first sub item */
      const firstSubItem = targetContent.querySelector('.tsm-sub-item');
      if (firstSubItem) activateSubItem(firstSubItem, targetContent, menu);
      else {
        /* No sub items — load direct product set */
        const directSet = targetContent.querySelector('.tsm-product-set.active');
        if (directSet) fetchProducts(directSet.dataset.collection, directSet);
      }
    }

    /* ══════════════════════════════════════
       COL 3 — SUB ITEMS
    ══════════════════════════════════════ */
    menu.querySelectorAll('.tsm-sub-item').forEach(item => {
      item.addEventListener('mouseenter', () => {
        const tabContent = item.closest('.tsm-tab-content');
        activateSubItem(item, tabContent, menu);
      });
    });

    function activateSubItem(item, tabContent, menu) {
      tabContent.querySelectorAll('.tsm-sub-item').forEach(i => i.classList.remove('active'));
      item.classList.add('active');

      /* Show matching product set */
      tabContent.querySelectorAll('.tsm-product-set').forEach(s => s.classList.remove('active'));
      const setId = item.dataset.productSet;
      const targetSet = tabContent.querySelector(`#${setId}`);
      if (targetSet) {
        targetSet.classList.add('active');
        fetchProducts(item.dataset.collection, targetSet);
      }
    }

    /* ══════════════════════════════════════
       INIT — load products for first visible set
    ══════════════════════════════════════ */
    const firstGroup   = menu.querySelector('.tsm-content-group.active');
    if (!firstGroup) return;
    const firstContent = firstGroup.querySelector('.tsm-tab-content.active');
    if (!firstContent) return;
    const firstItem    = firstContent.querySelector('.tsm-sub-item.active');
    if (firstItem) {
      const firstSet = firstContent.querySelector(`#${firstItem.dataset.productSet}`);
      if (firstSet) fetchProducts(firstItem.dataset.collection, firstSet);
    } else {
      const directSet = firstContent.querySelector('.tsm-product-set.active');
      if (directSet) fetchProducts(directSet.dataset.collection, directSet);
    }
  }

  /* ─────────────────────────────────────────
     BOOT — init once per menu on parent hover
  ───────────────────────────────────────── */
  document.querySelectorAll('.header-menu-item').forEach(item => {
    let initialized = false;
    item.addEventListener('mouseenter', () => {
      const menu = item.querySelector('[data-tsm]');
      if (menu && !initialized) {
        initialized = true;
        initMenu(menu);
      }
    });
  });

})();
